import { Button, MetaDefault } from '@terra/ui-design-system';
import { AlertCircleIcon, PlayIcon } from '@terra/ui-icons';
import { Box, HStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { useChatTurnInterruptedStore } from '../../store/chat-turn-interrupted-store';

type InterruptedTurnNoticeProps = {
  chatId: string;
  onContinue: (continuePrompt: string) => void;
};

export function InterruptedTurnNotice({
  chatId,
  onContinue,
}: InterruptedTurnNoticeProps) {
  const tCommon = useTranslations('common');
  const tInterrupted = useTranslations('chat.copilot.interruptedTurn');
  const isInterrupted = useChatTurnInterruptedStore((state) =>
    state.interruptedChatIds.has(chatId),
  );

  if (!isInterrupted) {
    return null;
  }

  return (
    <HStack
      gap={2}
      px={2}
      py={1}
      minH="30px"
      width="100%"
      minW={0}
      bg="bg.default"
      borderWidth="1px"
      borderBottomWidth="0"
      borderColor="border.subtle"
      borderTopRadius="md"
      data-testid="interrupted-turn-notice"
    >
      <Box color="fg.muted" display="flex" flexShrink={0}>
        <AlertCircleIcon size={14} />
      </Box>
      <MetaDefault
        color="fg.muted"
        flex="1"
        minW={0}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {tInterrupted('description')}
      </MetaDefault>
      <Button
        size="xs"
        variant="ghost"
        flexShrink={0}
        onClick={() => onContinue(tInterrupted('continuePrompt'))}
      >
        <PlayIcon size={12} />
        {tCommon('continue')}
      </Button>
    </HStack>
  );
}
